// Association financial year: 1 November – 31 October.
export const FY_START_MONTH = 11;
const iso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;

// Start year of the FY containing `now` (FY "2025/26" runs 1 Nov 2025 – 31 Oct 2026 and has start year 2025).
export const fyStartYear = (now = new Date()) => (now.getMonth() + 1 >= FY_START_MONTH ? now.getFullYear() : now.getFullYear() - 1);
export const fyRange = (startYear) => [iso(new Date(startYear, FY_START_MONTH - 1, 1)), iso(new Date(startYear + 1, FY_START_MONTH - 1, 0))];
export const currentFinancialYear = (now = new Date()) => fyRange(fyStartYear(now));
export const lastFinancialYear = (now = new Date()) => fyRange(fyStartYear(now) - 1);
export const fyLabel = ([from, to]) => `${from.slice(0, 4)}/${to.slice(2, 4)}`;
